export const home = {
  "Você tem assinaturas pendentes.": "You have pending signatures.",
  "Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.": "To resolve them, download the MarQ. app and make the requests.",
  "Baixe agora.": "Download now.",
  "Você tem uma admissão online em aberto.": "You have an online admission open.",
  "Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.": "To resolve it, download the MarQ. app and make the requests.",
  "Que tal relembrar ": "How about remembering ",
  "os seus momentos": "your moments",
  "com a gente?": "with us?",
  "Relembrar o meu ano": "Remember my year",
  "Retro": "Retro",
  "Você está em regime de sobreaviso": "You are on call",
  "Hora de início do regime:": "On-call start time:",
  "Hora de término do regime:": "On-call end time:",
  "Hora:": "Time:",
  "Último ponto registrado:": "Last clock-in:",
  "Nenhum ponto registrado": "No clock-in registered",
  "Horas faltantes": "Missing hours",
  "Jornada Completa": "Full workday",
  "Ver detalhes de hoje": "View todays details",
  "Ponto em processamento": "Clock-in in process",
  "Seu ponto das": "Your clock-in at",
  "já foi registrado!": "has already been registered!",
  "Atualize a página para visualizar o ponto.": "Refresh the page to view the clock-in.",
  "Atualizar página": "Refresh page",
  "Pausa iniciada em:": "Break started at:",
  "Você está em": "You are on",
  "pausa": "break",
  "Voltar da pausa": "Return from break",
  "Saldo de horas": "Hour balance",
  "Saldo acumulado desde": "Balance accumulated since",
  "Não lido": "Unread",
  "Detalhes": "Details",
  "Reuniões 1:1": "1:1 Meetings",
  "Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.": "Check your scheduled 1:1 meetings, after the end, dont forget to rate them.",
  "Novo lembrete": "New reminder",
  "Você tem um novo lembrete, clique aqui para ver os detalhes.": "You have a new reminder, click here to see the details.",
  "Tarefas pendentes": "Pending tasks",
  "Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes": "You have pending tasks in your name, click here to see the details",
  "Últimos 10 dias": "Last 10 days",
  "Ver histórico": "View history",
  "Data": "Date",
  "Trabalhado": "Worked",
  "Saldo": "Balance",
  "Status": "Status",
  "Nenhum registro": "No record",
  "Comunicados": "Statements",
  "Ver todos": "View all",
  "Nenhum comunicado": "No announcement",
  "Novo comunicado": "New announcement",
  "Assinatura": "Signature",
  "Você tem uma assinatura pendente, abra para regularizar a solicitação.": "You have a pending signature, open to regularize the request.",
  "Novo chat": "New chat",
  "Você tem uma nova mensagem no chat clique para ver a mensagem": "You have a new message in the chat click to view the message",
  "Admissão online": "Online admission",
  "Preencha aqui as informações necessárias de admissão": "Fill in the necessary admission information here",
  "Chegou um feedback": "Feedback received",
  "Você tem um novo Feedback, veja o que estão sentindo do seu trabalho": "You have new Feedback, see what they are feeling about your work",
  "Envio de documento": "Document submission",
  "Você tem um ou mais documentos pendentes para serem enviados": "You have one or more documents pending to be sent",
  "Espelho ponto": "Time sheet",
  "Você tem um ou mais espelhos de ponto para serem assinados": "You have one or more time sheets to be signed",
  "Ocorrências": "Occurrences",
  "Solicite os ajustes necessários para resolver as suas ocorrências": "Request the necessary adjustments to resolve your occurrences",
  "GET_MY_TEAMS": "GET_MY_TEAMS",
  "realodPage": "realodPage",
  "Férias": "Vacation",
  "Afastamento": "Leave",
  "Solicitado": "Requested",
  "Aprovado": "Approved",
  "Recusado": "Rejected",
  "Concluído": "Completed",
  "Ocorrência": "Occurrence",
  "Falta": "Absence",
  "Dia atual": "Current day",
  "Fechar": "Close",
  "Admissão": "Admission",
  "Este é o horário oficial central e pode estar diferente do horário do seu computador.": "This is the official central time and may be different from the time on your computer.",
  "dica de ferramenta": "tool tip",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.": "If you have any questions about your balance, please contact your HR or Manager.",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia": "If you have any questions about your balance, please contact your HR or Manager. The last update of the day history was made on",
  "Última atualização dos comunicados foi feita no dia": "The last update of the statement was made on"
};


// WEBPACK FOOTER //
// ./src/resources/enUS/home.js